import type { CallbackPlanId, CallbackStatus } from '@/types';

/** The four statuses the API accepts, in workflow order. */
export const CALLBACK_STATUSES: CallbackStatus[] = ['new', 'contacted', 'converted', 'dropped'];

export const STATUS_BADGE: Record<CallbackStatus, string> = {
    new: 'bg-[#FFF3EE] text-[#C2410C] border-[#FF6B35]/30',
    contacted: 'bg-blue-50 text-blue-700 border-blue-100',
    converted: 'bg-green-50 text-green-700 border-green-100',
    dropped: 'bg-gray-100 text-gray-600 border-gray-200',
};

const PLAN_LABEL: Record<CallbackPlanId, string> = {
    standard: 'Standard',
    enhanced: 'Enhanced',
    pro: 'Pro',
};

export const formatPlan = (planId: CallbackPlanId | null): string => (planId ? (PLAN_LABEL[planId] ?? planId) : '—');

/**
 * Compact relative age ("4m", "3h", "2d") — the queue is worked top-down by
 * recency, so exact timestamps only matter once a row is opened.
 */
export const formatAge = (iso: string): string => {
    const then = new Date(iso).getTime();
    if (Number.isNaN(then)) return '—';

    const seconds = Math.max(0, Math.floor((Date.now() - then) / 1000));
    if (seconds < 60) return 'just now';

    const minutes = Math.floor(seconds / 60);
    if (minutes < 60) return `${minutes}m ago`;

    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours}h ago`;

    const days = Math.floor(hours / 24);
    if (days < 30) return `${days}d ago`;

    return new Date(iso).toLocaleDateString();
};
